import { useSyncExternalStore } from 'react';

// New UI only: whether the page is loading, and whether the last load failed, read from what Classic already shows.
// Classic has one page-wide busy backdrop (bodyContainer.js, z-index 5000) and reports failed requests with an error
// toast, so no request code changes. Grids use this to say "Loading…" or "Couldn't load this list" instead of
// "Nothing to show" (redesign/grid/gridLook.js).

let state = { loading: false, failed: false };
const subs = new Set();
const emit = next => {
	if (next.loading === state.loading && next.failed === state.failed) return;
	state = next;
	subs.forEach(fn => fn());
};

export const loadState = () => state;
export const subscribeLoad = fn => { subs.add(fn); return () => subs.delete(fn); };
export const useLoadState = () => useSyncExternalStore(subscribeLoad, loadState, loadState);

// A load cycle starts when the backdrop shows. An error toast during it, or within a moment after, marks it failed; the
// next cycle starts clean.
const GRACE_MS = 1500;
let endedAt = 0;
export function noteBusy(busy, now = Date.now()) {
	if (busy && !state.loading) emit({ loading: true, failed: false });
	else if (!busy && state.loading) { endedAt = now; emit({ loading: false, failed: state.failed }); }
}
export function noteErrorToast(now = Date.now()) {
	if (state.loading || now - endedAt <= GRACE_MS) emit({ loading: state.loading, failed: true });
}
export function resetLoadState() { endedAt = 0; state = { loading: false, failed: false }; subs.forEach(fn => fn()); }

export const BUSY_SELECTOR = '.MuiBackdrop-root[style*="z-index: 5000"]';
export function backdropBusy(doc = document) {
	const el = doc.querySelector(BUSY_SELECTOR);
	if (!el) return false;
	const cs = doc.defaultView.getComputedStyle(el);
	return cs.visibility !== 'hidden' && cs.opacity !== '0' && el.style.visibility !== 'hidden';
}
